import React, { Component } from 'react';
import { getUser } from './GetUser';
import { loadCsrf } from './../common/CsrfFetcher';
import { FormError } from './../FormError';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import CountriesAndStates from './../helper/CountriesAndStates';
import OrgNameAlreadyExistsErrorModal from './../manageOrg/OrgNameAlreadyExistsErrorModal';
import validatePhone from './../helper/validatePhoneNumber';

class CreateOrganizationAccount extends Component {

	constructor(props) {
		super(props);
		this.state = {
			user: "",
			organizationName: {value:'', isValid: '', message:'Error: Please enter a valid organization name', hasErrorFocus: false},
			address1: {value:'', isValid: '', message:'Error: Please enter a valid address', hasErrorFocus: false},
			address2: {value:'', isValid: '', message:'', hasErrorFocus: false},
			city: {value:'', isValid: '', message:'Error: Please enter a valid city', hasErrorFocus: false},
			country:"",
			usState:"",
			nonUSStateProvince: {value:'', isValid: '', message:'Error: Please enter a valid state/province/region', hasErrorFocus: false},
			postalCode: {value:'', isValid: '', message:'Error: Please enter a valid postal code', hasErrorFocus: false},
			businessEmail: {value:'', isValid: '', message:'Error: Please enter a valid business email', hasErrorFocus: false},
			businessDescription: {value:'', isValid: '', message:'Error: Please enter a valid business description', hasErrorFocus: false},
			phoneNumber: {value:'', isValid: '', message:'Error: Please enter a valid phone number', hasErrorFocus: false},
			showSelectOrgToJoinModal:false,
			requestToJoinOrgErrorMessage:""	,
			countryError:"",
			usStateError:"",
			formErrors: [],
			showOrgNameAlreadyExistsErrorModal:false,
			disabled: true

		}
	}
	componentDidMount() {
		console.log('in CreateOrganizationAccount componentDidMount');
		getUser(this.updateFormWithOrgInfo);
		loadCsrf(this.setCsrfState);

	}

	getValidationState(isValid){
		if(isValid === '' || isValid === undefined){
		  return null;
		}
		if(isValid){
		  return 'success';
		}
		else {
		  return 'error';
		}
	  }

	updateFormWithOrgInfo = (currentUser) => {
		console.log('updating form with org info ' + currentUser);
		console.log('org name ' + currentUser.organization);
		this.setState({
			user: currentUser
		});
		if(currentUser.organization !== null)	{
			this.setState({
				address1: {value: currentUser.organization.contacts[0].address1},
				address2: {value: currentUser.organization.contacts[0].address2},
				organizationName: {value: currentUser.organization.name},
				city: {value: currentUser.organization.contacts[0].city},
				usState: currentUser.organization.contacts[0].state,
				nonUSStateProvince: {value: currentUser.organization.contacts[0].nonUSStateProvince},
				country: currentUser.organization.contacts[0].country,
				postalCode: {value: currentUser.organization.contacts[0].postalCode}
			});
		}
		if(currentUser.organization === null || currentUser.organization.length === 0)	{
			console.log('user does not have halo org');
			this.setState({
				disabled: false
			});
		}
	}

	setCsrfState = (csrfToken, csrfHeaderValue) => {
		var state = this.state;
		state.csrfToken = csrfToken;
		this.csrfHeaderValue = csrfHeaderValue;
		this.setState({
			state
		});
	}

	handleInputChange = (event) => {
		event.preventDefault();
		const target = event.target;
		const value = target.value;
		const name = target.name;

		this.setState({
			[name]: {value: value}
		});

		if(name === 'phoneNumber'){
			this.setState({
				phoneNumber: { value: value}
			})
			this.validatePhoneResponse(name, value)
		}

		if (value === "" && name === 'businessEmail') {
			this.setState({
				businessEmail: {isValid: false}
			});
		}
		if (value === "" && name === 'businessDescription') {
			this.setState({
				businessDescription: {isValid: false}
			});
		}
	}

    handleAlignErrors = (location, json) =>{
        var state = this.state;

        var field = json.validationErrors[location].field;
        var errorCode = json.validationErrors[location].errorCode;

        if(field === 'phoneNumber' && errorCode === "Pattern")	{
            state[field].isValid = false;
            state[field].message = 'Error: Please enter a valid Phone Number.';
        }
        else if (field === 'businessEmail' && errorCode === "Email")	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Please enter a valid business email.';
        }
        else if ((field === 'address1' || field === 'address2')  && errorCode === "Pattern")	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Please enter a valid address.';
        }
        else if (field === 'city' && errorCode === "Pattern")	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Please enter a valid city.';
        }
        else if (field === 'businessDescription' && errorCode === "Pattern")	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Please enter a valid business description.';
        }
        else if (field === 'name' && errorCode === "Size")	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Organization name is too long.';
        }
        else if (field === 'name' && errorCode === "Pattern")	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Please enter a valid organization name.';
        }
        else if (field === 'postalCode' && (errorCode === "Pattern" || errorCode === "Size"))	{
        	state[field].isValid = false;
        	state[field].message = 'Error: Please enter a valid postal code.';
        }
        else {
            state[field].isValid=false;
       }
       this.setState({state});
    }


	setSelectedState = (selectedState) => {
        console.log("setSelectedState received callback from child for " + selectedState);

        var state = this.state;
		state.usState = selectedState;
		state.nonUSStateProvince.value = '';
		state.nonUSStateProvince.message = '';
		console.log("selectedState is here: " + selectedState);

        if (selectedState === "Select" || selectedState === "") {
           this.setState({
				usStateError: "Error: Please select a State.",
			});
        } else {
			this.setState({
				usStateError: ""
			});
        }

        this.setState({
            state
		});
	}

    setSelectedNonUSState = (selectedNonUSState) => {
		console.log("setSelectedNonUSState received callback from child " + selectedNonUSState);

		var state = this.state;
		state.nonUSStateProvince.value = selectedNonUSState;

		if(state.nonUSStateProvince.value !== '')	{
			state.nonUSStateProvince.message = '';
			state.usState = '';
		}

		this.setState({
			state
		});
	  }

	setSelectedCountry = (selectedCountry) => {
        console.log("setSelectedCountry received callback from child " + selectedCountry);

        var state = this.state;
        state.country = selectedCountry;

        if (selectedCountry === "Select" || selectedCountry.includes("---") || selectedCountry === "") {
			this.setState({
				countryError: "Error: Please select a Country.",
			});
        } else{
            this.setState({
				countryError: ""
			});
        }

        this.setState({
            state
        });

	 }

	 showUSStatesDropdown = () => {
        if(this.state.country === 'Select' || this.state.country === 'UNITED STATES' || this.state.country === '') {
            return true;
        } else {
            return false;
        }
	}


	validatePhoneResponse = (fieldName, value) => {
        console.log('validate response is here!!!!!');
        const validatePhoneData = validatePhone(value)
        this.setState({
        	[fieldName]: validatePhoneData
		});
    }

	validateForm = () => {
		const createCorporateAccountForm = this.createCorporateAccountForm;
		const formValidationErrors = this.validate(createCorporateAccountForm);
		console.log('formValidationErrors ' + formValidationErrors);
		if (formValidationErrors.length > 0) {
			return false;
		} else {
			return true;
		}
	}

	validate = (createCorporateAccountForm) => {
		const formValidationErrors = [];

		const orgNameRegEx = /^(?=.*?[a-zA-Z0-9])[a-zA-Z0-9-.][A-Za-z0-9- .&*$@#!:;=_?%]*[A-Za-z0-9-.&*$@#!:;=_?%]$/;

		const formLength = createCorporateAccountForm.length;

		for (let index = 0; index < formLength; index++) {
			const elem = createCorporateAccountForm[index];

			if (elem.value === "" && elem.name === 'organizationName') {
				formValidationErrors.push("org name error");
				this.setState({
					organizationName: {isValid: false, message: 'Error: Please enter a Name.'}
				});
			}
			if (elem.value !== "" && elem.name === 'organizationName') {
				if (!elem.value.match(orgNameRegEx)) {
					formValidationErrors.push("org name regex error");
					this.setState({
						organizationName: {isValid: false, message: 'Error: Please use only English, alphanumeric characters. Spaces, periods, and these special characters are allowed - & * $ @ # ! : ; = ? _ % (no commas). Other than alphanumeric characters, only . and - are allowed at the beginning. No leading or trailing spaces.'}
					});
				}
			}

			if (elem.value === "Select" && elem.name === 'country') {
				formValidationErrors.push("country error");
				this.setState({
					countryError: "Error: Please select a Country."
				});
			}

			if (this.state.country === "UNITED STATES" && elem.name === 'usState' && elem.value === "Select") {
				formValidationErrors.push("us state  error");
				this.setState({
					usStateError: "Error: Please select a State."
				});
			} else if (this.state.country !== "UNITED STATES" && elem.name === 'nonUSStateProvince' && elem.value === "") {
				formValidationErrors.push("non us state error");
				this.setState({
					nonUSStateProvince: {isValid: false}
				});
			}

			this.validatePhoneResponse('phoneNumber', this.state.phoneNumber.value);

			if (elem.value === "" && elem.name === 'businessEmail') {
				formValidationErrors.push("business email error");
				this.setState({
					businessEmail: {isValid: false}
				});
			}
			if (elem.value === "" && elem.name === 'businessDescription') {
				formValidationErrors.push("businessDescription error");
				this.setState({
					businessDescription: {isValid: false}
				});
			}
		}

		return formValidationErrors;
	}

	handleCancel = (event) => {
		event.preventDefault();
		console.log("fetching the logout url  ");
		fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/firstnet/subscriber/getLogoutUrl', {
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			credentials: 'include'
		})
		.then(response => response.json())
		.then(data => {
			if (data != null) {
				console.log("logout url is " + data.url);
				window.location.href = data.url;
			}
		})
        .catch(error => {
			console.log('error trying to create subscriber corporate account: \n', error);
			return Promise.reject()
		})
	}

	handleFormSubmit = (event) => {

		event.preventDefault();

		if (this.validateForm()) {

				console.log('submitting request to create firstnet subscriber corporate account ' , this.state);
				console.log('csrf token ' + this.state.csrfToken);
				console.log('url is ' + process.env.REACT_APP_HOST_API_URL);
				fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/firstnet/subscriber/createOrganizationAccount', {
					method: 'post',
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'X-CSRF-TOKEN': this.state.csrfToken
					},
					body: JSON.stringify({
						name: this.state.organizationName.value,
						address1: this.state.address1.value,
						address2: this.state.address2.value,
						city: this.state.city.value,
						country: this.state.country,
						state: this.state.usState,
						nonUSStateProvince: this.state.nonUSStateProvince.value,
						postalCode: this.state.postalCode.value,
						phoneNumber: this.state.phoneNumber.value,
						businessEmail: this.state.businessEmail.value,
						businessDescription: this.state.businessDescription.value
					}),
					credentials: 'include'
				})

				.then(response => {
					console.log("response from createOrganizationAccount " , response);
					if (!response.ok) {
						console.log('response from service is ' + response.status);
						console.log("response is not ok " + response.statusText + " with status of " + response.status);
						if (response.status === 400) {
							return response.json();
						} else if (response.status === 401) {
							window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/auth/login";
							return null;
						} else if (response.status === 409) {
							console.log(response);
							this.setState({
								showOrgNameAlreadyExistsErrorModal: true
							});
							return null;
						}
						throw new Error("Unknown Problem occurred : " + response.statusText);
					} else if (response.ok) {
						if(this.state.user.type === 'FN_NON_SUBSCRIBER')	{
							window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/registrationConfirmationFNPage.jsp";
						} else	{
							console.log('response from createOrganizationAccount is 200, so continue to MMA page');
							window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/mvc/auth/loginsuccess?destPage=/developer/mvc/manageMyAccount";
						}
					}
				})

				.then(json => {
					if (json != null) {
						console.log("server side validation errors " , json);
						for (var i = 0; i < json.validationErrors.length; i++) {
							this.handleAlignErrors(i, json);
						}

					}
				})
				.catch(error => {
					console.log('error trying to create subscriber corporate account : \n', error);
					window.location.href = process.env.REACT_APP_HOST_API_URL + "/developer/errorRedirect.jsp?errorKey=request.processing.error";
					return Promise.reject()
				})
		}
	}

	hideOrgNameAlreadyExistsErrorModal = () => {
		console.log("hideOrgNameAlreadyExistsErrorModal");
		this.setState({
			showOrgNameAlreadyExistsErrorModal: false
		});
	}

	errorClass = (elementName) => {
		var errorName = elementName + 'Error';
		return (this.state[errorName] === '' ? 'has-success' : 'has-error');
	}

	hideClass(element) {
		console.log(element);
		if (this.state.organizationName.message !== '') {
			return 'show';
		} else {
			return 'hide';
		}
	}


	render () {
		return (
			<div className = "col-12">
				<div className = "row">
					<div className = "col-6 form-heading"> <strong className = "text-gray-dark" > Required Fields </strong><strong className="text-red"> *</strong ></div>
					<div className = "col-12"><hr/></div>
				</div>
				<div className="row">
					<div className="col-12">
						<form id="createCorporateAccountForm" name="createCorporateAccountForm" className="customForm" ref={form => (this.createCorporateAccountForm = form)} onSubmit={this.handleFormSubmit}>
							<div className="row">
								<FormGroup id="organizationName" className="col-12" validationState={this.getValidationState(this.state.organizationName.isValid)}>
									<ControlLabel>Organization/Company Name <strong className="text-red"> *</strong ></ControlLabel>
									<FormError errorMessage={this.state.organizationName.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													aria-required="true" aria-describedby=""
													name="organizationName"
													type="text"
													autoComplete="nope"
													onChange={this.handleInputChange}
													value={this.state.organizationName.value}
													disabled={this.state.disabled}/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
							<FormGroup id="address1" className="col-12" validationState={this.getValidationState(this.state.address1.isValid)}>
									<ControlLabel>Organization/Company Street Address 1 <strong className="text-red"> *</strong ></ControlLabel>
									<FormError errorMessage={this.state.address1.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													aria-required="true" aria-describedby=""
													name="address1"
													type="text"
													value={this.state.address1.value}
													onChange={this.handleInputChange}
													disabled={this.state.disabled}/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup id="address2" className="col-12" validationState={this.getValidationState(this.state.address2.isValid)}>
									<ControlLabel>Organization/Company Street Address 2 </ControlLabel>
									<FormError errorMessage={this.state.address2.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													aria-describedby=""
													name="address2"
													type="text"
													value={this.state.address2.value}
													onChange={this.handleInputChange}
													disabled={this.state.disabled}/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup id="city" className="col-12" validationState={this.getValidationState(this.state.city.isValid)}>
									<ControlLabel>Organization/Company City <strong className="text-red"> *</strong ></ControlLabel>
									<FormError errorMessage={this.state.city.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													aria-required="true" aria-describedby=""
													name="city"
													type="text"
													value={this.state.city.value}
													onChange={this.handleInputChange}
													disabled={this.state.disabled}/>
										</div>
									</div>
								</FormGroup>
							</div>
							<CountriesAndStates updateSelectedState={this.setSelectedState} updateSelectedCountry={this.setSelectedCountry} updateSelectedNonUSState={this.setSelectedNonUSState}
        										countryError={this.state.countryError} usStateError={this.state.usStateError} nonUSStateError={this.state.nonUSStateProvince.message}
        										selectedCountry={this.state.country} selectedState={this.state.usState} selectedNonUSState={this.state.nonUSStateProvince.value}
          										errorClass={this.errorClass()} showUSStatesDropdown={this.showUSStatesDropdown} disabled={this.state.disabled}/>
							<div className="row">
								<FormGroup id="postalCode" className="col-12" validationState={this.getValidationState(this.state.postalCode.isValid)}>
									<ControlLabel>Organization/Company Postal Code <strong className="text-red"> *</strong ></ControlLabel>
									<FormError errorMessage={this.state.postalCode.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													aria-required="true" aria-describedby=""
													name="postalCode"
													type="text"
													value={this.state.postalCode.value}
													onChange={this.handleInputChange}
													disabled={this.state.disabled}/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup id="phoneNumber" className="col-12" validationState={this.getValidationState(this.state.phoneNumber.isValid)}>
									<ControlLabel>Organization/Company Phone Number <strong className="text-red"> *</strong ></ControlLabel>
									<FormError errorMessage={this.state.phoneNumber.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													name="phoneNumber"
													type="text"
													value={this.state.phoneNumber.value}
													onChange={this.handleInputChange}
													maxLength="30"/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup id="businessEmail" className="col-12" validationState={this.getValidationState(this.state.businessEmail.isValid)}>
									<ControlLabel>Organization/Company Email <strong className="text-red"> *</strong ></ControlLabel>
									<FormError errorMessage={this.state.businessEmail.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<input	className="form-control"
													name="businessEmail"
													type="text"
													value={this.state.businessEmail.value}
													onChange={this.handleInputChange}/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup id="businessDescription" className="col-12" validationState={this.getValidationState(this.state.businessDescription.isValid)}>
									<ControlLabel>Organization/Company Description <strong className="text-red"> *</strong ></ControlLabel>
									<a href="#" id="org_business_description_tooltip" className="tooltipLink hidden-xs hidden-sm" data-bs-trigger="focus" tab-index="0" aria-label="Organization description tooltip" data-bs-toggle="popover" data-bs-placement="top" data-bs-content="Enter alphanumeric characters in English only. Use only spaces, hyphens, period, and underscores (no commas). Enter no more than one space between characters.">
										<img role="tooltip" className="tooltipIcon" src="/developer/images/info-tooltips.png" onmouseover="this.src='/developer/images/info-tooltips-hover.png'" onmouseout="this.src='/developer/images/info-tooltips.png'" alt="Organization description Tooltip"/>
									</a>
									<FormError errorMessage={this.state.businessDescription.message}/>
									<div className="row">
										<div className="col-12 col-md-6">
											<textarea className="form-control"
												name="businessDescription"
												value={this.state.businessDescription.value}
												onChange={this.handleInputChange}
												rows="3"
												maxLength="255"/>
										</div>
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup className="col-12">
									<strong>TERMS &amp; CONDITIONS</strong>
									<div>
										NOTE: By clicking Create button below, you agree to the &nbsp;
											<a href="/firstnet/firstnet-developer-program-terms-and-condition" target="_blank">FirstNet Developer Terms and Conditions</a>.
									</div>
								</FormGroup>
							</div>
							<div className="row">
								<FormGroup className="col-6 text-left">
									<input name="cancelButton" id="cancelButton" className="button secondary light-bg" type="button" value="Cancel" aria-label="Cancel" onClick={this.handleCancel}/>
								</FormGroup>
								<FormGroup className="col-6 text-right">
									<input name="submitButton" id="submitButton" className="button secondary light-bg" type="submit" value="Create" aria-label="Create"/>
								</FormGroup>
							</div>
						</form>
					</div>
				</div>
				<OrgNameAlreadyExistsErrorModal showOrgNameAlreadyExistsErrorModal={this.state.showOrgNameAlreadyExistsErrorModal} hideOrgNameAlreadyExistsErrorModal={this.hideOrgNameAlreadyExistsErrorModal}/>
			</div>
		)
	}
}

export default CreateOrganizationAccount;



// WEBPACK FOOTER //
// ./src/firstnetSubscriberOnboarding/CreateOrganizationAccount.js